import pako from "pako";
import {
  encode as msgpackEncode,
  decode as msgpackDecode,
} from "@msgpack/msgpack";

const toBase64Url = (bytes: Uint8Array): string => {
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  const base64 =
    typeof btoa === "function"
      ? btoa(binary)
      : Buffer.from(binary, "binary").toString("base64");
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const fromBase64Url = (input: string): Uint8Array => {
  const padded = input.replace(/-/g, "+").replace(/_/g, "/");
  const pad =
    padded.length % 4 === 0 ? "" : "=".repeat(4 - (padded.length % 4));
  const binary =
    typeof atob === "function"
      ? atob(padded + pad)
      : Buffer.from(padded + pad, "base64").toString("binary");
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

export const encodeMemory = (memory: unknown): string => {
  const packed = msgpackEncode(memory);
  const deflated = pako.deflate(packed, {
    level: 9,
    windowBits: 15,
    memLevel: 9,
    strategy: pako.constants.Z_DEFAULT_STRATEGY,
    raw: false,
  });
  return toBase64Url(deflated);
};

export const decodeMemory = (encoded: string): unknown => {
  const deflated = fromBase64Url(encoded);
  const packed = pako.inflate(deflated);
  try {
    return msgpackDecode(packed);
  } catch {
    // Legacy format: state used to be deflate(JSON.stringify(memory)) instead
    // of MessagePack. Old shared links carry UTF-8 JSON in the inflated bytes,
    // so fall back to JSON parsing to keep those links working.
    const text =
      typeof TextDecoder === "function"
        ? new TextDecoder().decode(packed)
        : Buffer.from(packed).toString("utf8");
    return JSON.parse(text);
  }
};
